/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import React, { memo } from "react";
import { TarjetaPropiedad } from "@/components/geospatial/map-search/ui/tarjeta-propiedad";
import { parseListingImages } from "@/lib/listing-images";

type ListingPreviewProps = {
  listing: any;
  locale?: string;
};

/**
 * El nombre tal como lo escribe el buscador. Aquí llega de la base sin pasar por la
 * normalización del índice de Algolia: «vara de quart», «València».
 */
const nombreDeZona = (nombre?: string | null): string | undefined => {
  const limpio = nombre?.trim().replace(/^València$/, "Valencia");
  return limpio ? limpio.charAt(0).toUpperCase() + limpio.slice(1) : undefined;
};

/** La zona más concreta, con la misma prioridad que el buscador. */
const zonaDeFicha = (listing: any) =>
  nombreDeZona(listing.neighborhood_final || listing.mapbox_place || listing.witei_city);

/** Segundos desde 1970, como el campo equivalente de Algolia. */
const altaDeFicha = (listing: any): number | undefined => {
  const fecha = Date.parse(listing.witei_created_at ?? listing.created_at ?? "");
  return Number.isNaN(fecha) ? undefined : Math.floor(fecha / 1000);
};

/** La tarjeta de la portada: la misma que el panel y el mapa de /propiedades. */
const ListingPreviewComponent = ({ listing, locale = "es" }: ListingPreviewProps) => (
  <TarjetaPropiedad
    titulo={locale === "es" ? listing.title_es : listing.title_en}
    images={parseListingImages(listing.witei_images || listing.display_images)}
    slug={`/${locale === "es" ? listing.slug_es : listing.slug_en}`}
    referencia={listing.reference_code}
    agreement_type={locale === "es" ? listing.operation_type_es : listing.operation_type_en}
    price_sale={listing.price_sale}
    price_rent={listing.price_rent}
    transfer={listing.transfer}
    transfer_sale={listing.transfer_sale}
    transfer_rent={listing.transfer_rent}
    rooms={listing.rooms}
    bathrooms={listing.bathrooms}
    sqmts={listing.sqmts}
    caracteristicas={listing.tags_es ?? null}
    zona={zonaDeFicha(listing)}
    provincia={nombreDeZona(listing.witei_province)}
    publicadaEl={altaDeFicha(listing)}
    cta={locale === "es" ? "Ver propiedad" : "See property"}
    locale={locale}
  />
);

// Memoize the component to prevent unnecessary re-renders
export const ListingPreview = memo(ListingPreviewComponent);
